import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Button from "./Button";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../state/index";
import { isMobile } from "react-device-detect";

import Modal from "./Modal";
import AuthModal from "./modals/Authentication";

import { ReactComponent as FollowIcon } from "../img/icons/follow.svg";
import { ReactComponent as WarningIcon } from "../img/icons/warning.svg";
import { ReactComponent as UnfollowIcon } from "../img/icons/heart.svg";
import { ReactComponent as FollowedIcon } from "../img/icons/heart2.svg";

const FollowUnfollow = ({ noIcons, followed, ...rest }) => {
  const [isFollowed, setIsFollowed] = useState(true);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  useEffect(() => {
    setIsFollowed(followed);
  }, [followed]);

  if (isLoggedIn === undefined || isFollowed === undefined) return null;
  if (isLoggedIn && isFollowed)
    return <Unfollow setIsFollowed={setIsFollowed} noIcons={noIcons} {...rest} />;
  return (
    <Follow setIsFollowed={setIsFollowed} noIcons={noIcons} isLoggedIn={isLoggedIn} {...rest} />
  );
};
export default FollowUnfollow;

const Follow = (props) => {
  const dispatch = useDispatch();
  const { logout } = bindActionCreators(actionCreators, dispatch);
  const [modal, setModal] = useState(false);

  const handleFollow = () => {
    if (!props.isLoggedIn) setModal(true);
    else
      axios
        .post(
          process.env.REACT_APP_FOLLOW_ENDPOINT,
          { channelId: props.channelId },
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          props.setIsFollowed(true);
          toast.success("Followed");
        })
        .catch((error) => {
          if (error?.response?.status === 401) logout();
          else if (error.response) {
            if (error?.response?.status === 400)
              toast.info("Following jnoun is not implemented yet.");
            if (error?.response?.status === 500) toast.error("Internal server error.");
          } else if (error.request) toast.info("We are experiencing service outages.");
          else toast.error.dark("Something is blocking you from accessing our servers.");
        });
  };

  return (
    <>
      <Modal
        isOpen={modal}
        onRequestClose={() => setModal(false)}
        hideModal={() => setModal(false)}
      >
        <AuthModal tabIndex={1} hideModal={() => setModal(false)} />
      </Modal>
      <Button size={isMobile ? "" : "small"} variant="primary" onClick={handleFollow} {...props}>
        {props.noIcons || <FollowIcon />}
        Follow
      </Button>
    </>
  );
};
const Unfollow = (props) => {
  const [follow, setFollow] = useState("followed");
  const [unfollowModal, setUnfollowModal] = useState(false);
  const dispatch = useDispatch();
  const { logout } = bindActionCreators(actionCreators, dispatch);

  function hideModal() {
    setUnfollowModal(false);
  }
  function showModal() {
    setUnfollowModal(true);
  }
  const handleUnfollow = () => {
    axios
      .post(
        process.env.REACT_APP_UNFOLLOW_ENDPOINT,
        { channelId: props.channelId },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        props.setIsFollowed(false);
        // toast.info("UnSubscribed");
      })
      .catch((error) => {
        if (error?.response?.status === 401) logout();
        else if (error.response) {
          if (error?.response?.status === 400)
            toast.error("Unfollowing jnoun is not implemented yet.");
          if (error?.response?.status === 500) toast.error("Internal server error.");
        } else if (error.request) toast.error("We are experiencing service outages.");
        else toast.error("Something is blocking you from accessing our servers.");
      });
    setUnfollowModal(false);
  };

  return (
    <>
      <Button
        size="small"
        variant="secondary"
        onMouseEnter={() => setFollow("unfollow")}
        onMouseLeave={() => setFollow("followed")}
        onClick={() => showModal()}
        {...props}
      >
        {!props.noIcons && follow === "followed" ? <FollowedIcon /> : <UnfollowIcon />}
        {follow}
      </Button>
      <Modal isOpen={unfollowModal} onRequestClose={hideModal} hideModal={hideModal}>
        <div style={{ textAlign: "center" }}>
          <WarningIcon />
          <p className="large" style={{ margin: "30px 0" }}>
            You sur you want to INFOLLOW this channel?!
          </p>
          <div style={{ display: "flex" }}>
            <Button
              variant="secondary"
              onClick={hideModal}
              style={{ flex: "1", marginRight: "10px" }}
            >
              Cancel
            </Button>
            <Button variant="danger" onClick={handleUnfollow} style={{ flex: "1" }}>
              Unfollow
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};
